const options = {
    rootClass: 'zp-no-fixed-slider',
    initType: 1
};

LoaderFactory(options, (function (w, d, $, undefined) {

    const _w = $(w);
    const _d = $(d);

    class NoFixedSlider {


        /**
         * Konstruktor
         * @param {Selector} root
         */
        constructor(root) {

            this.slider = null;
            this.isCarouselVisible = false;
            this.initTouchCarousel(root);
            this.start(root);
        }


        /**
         * foo
         * @param {Selector} root
         */
        start(root) {

            this.resizeImage(root);

        }

        /**
         * initialisiert Touch Carousel
         * @param {Selector} root
         */
        initTouchCarousel (root) {

            let carousel = $('#' + root.attr('id') + " .zp-no-fixed-slider-container");

            let autoplay = carousel.data('autoplay');
            let autoplaySpeed = parseInt(carousel.data('autoplay-speed'));
            let imgWidth = parseInt(carousel.data('width'));

            this.slider = carousel.touchCarousel({

                itemsPerMove: 1,              // The number of items to move per arrow click.

                snapToItems: false,           // Snap to items, based on itemsPerMove.
                pagingNav: false,             // Enable paging nav. Overrides snapToItems.
                                              // Snap to first item of every group, based on itemsPerMove.

                pagingNavControls: false,     // Paging controls (bullets).

                autoplay: autoplay,                // Autoplay enabled.
                autoplayDelay: 1,	          // Delay between transitions.
                autoplayStopAtAction: false,  // Stop autoplay forever when user clicks arrow or does any other action.

                scrollbar: false,             // Scrollbar enabled.
                scrollbarAutoHide: true,      // Scrollbar autohide.
                scrollbarTheme: "dark",       // Scrollbar color. Can be "light" or "dark".

                transitionSpeed: autoplaySpeed,       // Carousel transition speed (next/prev arrows, slideshow).

                directionNav:false,           // Direction (arrow) navigation (true or false).
                directionNavAutoHide:false,   // Direction (arrow) navigation auto hide on hover.
                                              // On touch devices arrows are always displayed.

                loopItems: true,             // Loop items (don't disable arrows on last slide and allow autoplay to loop).

                keyboardNav: false,           // Keyboard arrows navigation.
                dragUsingMouse:true,          // Enable drag using mouse.

                scrollToLast: false,          // Last item ends at start of carousel wrapper.


                itemFallbackWidth: imgWidth,       // Default width of the item in pixels. (used if impossible to get item width).

                baseMouseFriction: 0.0012,    // Container friction on desktop (higher friction - slower speed).
                baseTouchFriction: 0.0008,    // Container friction on mobile.
                lockAxis: true,               // Allow dragging only on one direction.
                useWebkit3d: false,            // Enable WebKit 3d transform on desktop devices.
                // (on touch devices this option is turned on).
                // Use it if you have only images, 3d transform makes text blurry.

                onAnimStart: null,            // Callback, triggers before deceleration or transition animation.
                onAnimComplete: null,         // Callback, triggers after deceleration or transition animation.

                onDragStart:null,             // Callback, triggers on drag start.
                onDragRelease: null           // Callback, triggers on drag complete.

            }).data("touchCarousel");

            if (!this.isCarouselVisible) {

                this.isCarouselVisible = true;
                this.visibleSlideElements(root);

            }


        }

        resizeImage (root) {

            let carousel = $('#' + root.attr('id') + " .zp-no-fixed-slider-container");
            let imgWidth = parseInt(carousel.data('width'));
            let img = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .zp-no-fixed-slider-element:first-child img");
            let imgWidthOnTag = img.attr('width');
            let windowWidth = window.innerWidth;

            if (windowWidth < imgWidth) {
                this.reinitTouchCarousel(root, windowWidth-60);
            }
            else if (imgWidth == imgWidthOnTag) {

            }
            else {
                this.reinitTouchCarousel(root, imgWidth);
            }

            _w.on('resize', () => {

                let img = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .zp-no-fixed-slider-element:first-child img");
                let imgWidthOnTag = img.attr('width');
                let windowWidth = window.innerWidth;

                if (windowWidth < imgWidth) {
                    this.reinitTouchCarousel(root, windowWidth);
                }
                else if (imgWidth == imgWidthOnTag) {
                    this.reinitTouchCarousel(root, imgWidth);
                }
                else {
                    this.reinitTouchCarousel(root, imgWidth);
                }

            });

        }

        reinitTouchCarousel (root, width) {
            // let carousel = $('#' + root.attr('id') + " .zp-no-fixed-slider-container");
            // let imgWidth = parseInt(carousel.data('width'));
            // let rootTag = $('#' + root.attr('id'));
            let container = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .touchcarousel-container");
            let slideElements = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .zp-no-fixed-slider-element");
            let imgs = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .zp-no-fixed-slider-element img");
            //
            // let cnt = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .touchcarousel-wrapper").contents();
            // $('#' + root.attr('id') + " .zp-no-fixed-slider-container .touchcarousel-wrapper").replaceWith(cnt);
            //
            // carousel = $('#' + root.attr('id') + " .zp-no-fixed-slider-container").clone();
            // this.sliderData.destroy();
            // rootTag.append(carousel);
            // imgs = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .zp-no-fixed-slider-element img");
            imgs.attr('width', width);
            // slideElements = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .zp-no-fixed-slider-element");
            slideElements.css('width', width+'px');
            // ul = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .touchcarousel-container");
            container.css('width', (width*this.slider.numItems)+'px');
            // // console.log('EY');
            // // console.log(carousel);
            // // console.log('JO');
            // console.log(this.slider.updateCarouselSize);
            // this.slider.updateCarouselSize();

            //Destroy all slider events
            let touchcarouselContainer = $('#' + root.attr('id') + ' .touchcarousel-wrapper > ul');
            touchcarouselContainer.unwrap();
            this.slider.stopAutoplay();
            this.slider._itemsWrapper.unbind(this._downEvent);
            $(document).unbind(this.slider._moveEvent).unbind(this.slider._upEvent);
            $(window).unbind(this.slider._resizeEvent);
            if(this.slider.settings.keyboardNav) {
                $(document).unbind("keydown.touchcarousel");
            }
            //Reinit Slider
            this.slider.updateCarouselSize();
            this.initTouchCarousel(root);
        }

        visibleSlideElements (root) {

            let noFixedSlider = $('#' + root.attr('id'));
            let slideElements = $('#' + root.attr('id') + " .zp-no-fixed-slider-container .zp-no-fixed-slider-element");
            let numberSlideElements = this.slider.numItems;

            noFixedSlider.addClass('init-carousel');

            setTimeout(() => {
            let delay;
                slideElements.each((index, slideElement) => {

                    let _slideElement = $(slideElement);


                        console.log(_slideElement);
                        delay = index*80;

                        _slideElement.css('transition-delay', delay+'ms');
                        _slideElement.addClass('visible');


                });
            }, 80);


        }


    }

    return NoFixedSlider;

}(window, document, jQuery)));